import { Component, OnInit,AfterViewInit, ElementRef, ViewChild,ComponentFactoryResolver,NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,EventEmitter,SimpleChanges} from '@angular/core';
import {BrowserModule, DomSanitizer, Title} from '@angular/platform-browser'
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import { LayerService } from '../inservice/layer.service';
import {Utils} from '../_util/utils';
//import * as Editor from '../ckeditor5/build/ckeditor';
//import { InlineEditor, Autoformat, Bold, Essentials, Italic, List, Mention, Paragraph, Undo, type EditorConfig } from 'ckeditor5';
import {UploadService} from '../_services/index';
import {HttpClient} from '@angular/common/http';
import { InjectDirective } from '../_directive/inject.directive';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-cover',
  templateUrl: './cover.component.html',
  styleUrls: ['./cover.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CoverComponent implements OnInit, OnChanges, OnDestroy  {
	logoInfo=[];
	userInfo:any;
	userId:string;
	userName="User";
	r:string;
	tableContent=[];
	displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
	//public Editor = InlineEditor;
	public current:any;
	public covers=[];
	public pages=[];
	public bks=[];
	public others=[];
	public photos=[];
	public logos=[];
	public headers=[];
	public footers=[];
	public uploadedFiles=[];
	public groupSlots=[];
	public addLib=false;
	public itemIndex=0;
	public isExpanded=false;
	public expandedRows = {};
	public cols2:any[];
	public cols3:any[];
	public cols6:any[];
	loading=false;
	imgGroup='other';
	uploadFiles=0;
	uploadTotal=0;
	uploadNo=0;
	public selectIndex=0;
	public selectedEditor='C';
	public addedSlot=[];
	public addedHSlot=[];
	public addedFPara=[];
	public addedHPara=[];
	public addedFSlot=[];
	public addedHContent:any;
	public addedFContent:any;
	public hContent:string;
	public savedHContent:string;
	public savedHTML:any;
	public savedCHTML=[];
	public fContent:string;
	public savedFContent:string;
	public editType="C";
	public hHeight=80;
	public fHeight=80;
	public logOutFlag=0;
	public selectedContainer;
	public selectedImage;
	public selectedInsert=[];
	public ckconfig:any;
	public docs=[];
	public convertDocs=[];
	public docList=[];
	public docIndex:number;
	public sectionIndex=0;
	public currentDocIndex:string;
	public srcPage='dsContainer';
	public getSecData=0;
	public startP=0;
	public outDoc=[];
	public outDoc1:string;
	private fileReader: FileReader;
	public pageMargin={'top':'0', 'bottom':"0", 'left':"0", 'right':"0"};
	public portraitSize={'width':'816','height':'1054'};
	public landscapeSize={'width':'1054','height':'816'};
	public selectpage={'type':'portrait', 'size':{'width':'816','height':'1054'}};
	public selectPdi='600';
	public selectFont="times new roman";
	public lineSpace="0";
	public content='';//'<figure class="image image_resized" style="width:22.65%;"><img src="./assets/images/logo.png"></figure>';
	public showLogo=0;
	public rowData;
	public outData:string;
	public savedData:any;
	public testData:any;
	public htmlStr2;
	public uploadType:string;
	public bimageurl="";
	public paraIndex=0;	
	public samples:any;
	public sourceCode="";
	public sourceHFCode="";
	public sourceCCode=[];
	public cIndex=0;
	dataInput='HTML';
	htmlShow=false;
	htmlCShow=false;
	dragDisabled=false;
	acceptType=[];
	@ViewChild(InjectDirective) injectComp: InjectDirective;
	@ViewChild("viewer") viewer: ElementRef;
	@ViewChild("viewer2") viewer2: ElementRef;
	@ViewChild("viewer3") viewer3: ElementRef;
	@ViewChild('file') file: ElementRef;
	@ViewChild('file1') file1: ElementRef;
	//@ViewChild("header") hContent: ElementRef;
	//@ViewChild("footer") fContent: ElementRef;
  constructor(private location: Location, private titleService :Title, private sanitizer: DomSanitizer, private uls: UploadService, private http:HttpClient, private componentFactoryResolver: ComponentFactoryResolver,private router: Router,private layerService: LayerService,
  public  reportService: ReportService, private zone: NgZone, private cookieService:CookieService,private route: ActivatedRoute
              ) { 
	router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element) { element.scrollIntoView(); }
        }
      }
    });
	//this.getOrderDetail();
	let page=decodeURI(this.route.snapshot.paramMap.get('id'));
	if(this.cookieService.getCookie("userID")) {
						this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
						this.userId = this.cookieService.getCookie("userID");
						this.userName = this.cookieService.getCookie("userName");
						this.r=this.cookieService.getCookie("r");
						//this.getAllTemplate(this.userId);
						this.getAllCover(parseInt(this.userId));
						this.getAllHeader(parseInt(this.userId));
						this.getAllFooter(parseInt(this.userId));
						//this.getAllTmp(parseInt(this.userId));
						this.getAllBk(parseInt(this.userId));
						this.getLogo();
						this.getSlots(parseInt(this.userId));
						this.checkPermit();
						if(page!='null'){
							let data=page.split('-');
							let id=parseInt(data[1]);
							if(data[0]=='Cover'){
								this.getCoverPage(id);
							}else{
								this.getHF(id);
							}
						}else{
							this.newCover();
						}
						this.getHFSamples();
	} else {
		this.cookieService.clearAll();
		this.router.navigate(['/']);		
	}
	this.acceptType=this.reportService.acceptFileType.split(',');
	}
	getOrderDetail(){
		if(this.cookieService.getCookie("userID")) {
						this.userId = this.cookieService.getCookie("userID");
						this.userName = this.cookieService.getCookie("userName");
						this.r=this.cookieService.getCookie("r");
						//this.getAllTemplate(this.userId);
						this.getAllCover(parseInt(this.userId));
						//this.getAllTmp(parseInt(this.userId));
						this.getAllBk(parseInt(this.userId));
		} else {
			this.userId=null;			
		}
	}
	allowEdit='Y';
	allowAdd='Y';
	checkPermit(){
		let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"FUNCTION_ID":39}; 
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION){;
					this.allowEdit=data.USER_PERMISSION;
				}
			}else{
				this.throwError(data);
			}
		})
		let inputJson1={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"FUNCTION_ID":40}; 
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION){;
					this.allowAdd=data.USER_PERMISSION;
				}
			}else{
				this.throwError(data);
			}
		})
	}
	getSlots(id){
		let inputJson={"PROCEDURE":"getslotsbycategory", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.groupSlots=data.RW_SLOT_CATEGORIES;
			}
		})
	}
	getHFSamples(){
		this.reportService.getHFSample().subscribe(data => {
			this.samples=data;
		})
	}
	ngOnInit(): void {
		
		let w = Math.floor(Utils.mmToPx(279, this.reportService.dpi));
		let h = Math.floor(Utils.mmToPx(216, this.reportService.dpi));
		//this.newCover();
		this.cols2 = [			
			{ field: 'CATEGORY', header: 'Categroy', width: '92%' },
			//{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols3 = [			
			{ field: 'KEY', header: 'label', width: '30%' },
			{ field: 'CONTENT', header: 'Content', width: '60%' },		
			{ field: '', header: '' , width: '10%' },
				
        ];
		this.cols6 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'FILE_NAME', header: 'File Name', width: '40%' },
			{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
			{ field: 'PROJECT_ID', header: 'Project Name', width: '15%' },
			{ field: 'REPORT_ID', header: 'Report Type ' , width: '14%' },
			{ field: 'USER_ID', header: 'Upload By ' , width: '12%' },
			{ field: 'FILE_ID', header: 'Date ' , width: '8%' },
				
        ];
		$(document).ready(function () {
			$('#fileModal').draggable();
			$('#viewerModal').draggable();
			$('#srcModal').draggable();
		});
	}
	ngOnChanges(changes: SimpleChanges): void {
      
		//if ('user' in changes) {
		//	this.loginInfo=this.user;
		//}
	}
	ngOnDestroy(): void {
		//document.removeEventListener('contextmenu', this.handleContextMenu);
		//this.reportService.editNotify.unsubscribe();
  }
	public onInfo(e){
	  this.getOrderDetail();
	}

 saveCover(){
	  this.outDoc=[];
	  this.getCoverData();
	  $('#overlay').css('display','block');
	 setTimeout(() => {
		this.generatePdf();
	}, 500);
	
 }
  public ckData(e, id, index){
	 this.outDoc[index]=e; 
	 this.pages[index].eData=e;
	 this.docs[id]=e;
	 this.convertDocs[id]=this.toStyle(e);
	
  }
  public ckData1(e){
	 this.outDoc1=e; 
  }
  
	save(type, htmlurl, pdfurl){
		$('#overlay').css('display','none');
		let that=this;
		if(!this.current||!this.current.COVERPAGE_TITLE||this.current.COVERPAGE_TITLE.length==0){
		Swal.fire({
			title: 'Please input cover name',
			inputAttributes: {
			autocapitalize: 'off'
		},
      html: '<input type="text" #covername id="covername" class="form-control mb-2" placeholder="Enter your template name"></input>',
      confirmButtonText: 'Save',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      backdrop:false,
      preConfirm: () => {
        let name = $('#covername').val();// Swal.getPopup().querySelector('#username').value;
        if (name === '') {
          Swal.showValidationMessage(`Cover Page name empty`)
        }
		$('#overlay').css('display','block');
		let inputJson={"PROCEDURE":"insertcoverpage", "USER_ID":parseInt(that.userId), "COVERPAGE_TITLE":name, "COVERPAGE_URL":pdfurl, "COVERPAGE_HTML_URL":htmlurl, "COVERPAGE_DATA":that.outData};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
			if(result.RESPONSE_STATUS=='N'){
				this.throwError(result);
				
			}else{
			let data={'COVERPAGE_ID': result.COVERPAGE_ID,'COVERPAGE_TITLE': result.COVERPAGE_TITLE,'COVERPAGE_URL':result.COVERPAGE_URL, "COVERPAGE_HTML_URL":result.COVERPAGE_HTML_URL,};
			that.covers.push(data);	
			this.current=data;
			this.titleService.setTitle("Cover"+' - '+data.COVERPAGE_TITLE);
			this.location.go('/cover/Cover-'+result.COVERPAGE_ID.toString());
			$('#overlay').css('display','none');
			}
		})		
      }
    })
	}else{
		$('#overlay').css('display','block');
		//let inputJson={"PROCEDURE":"insertcoverpage", "USER_ID":that.userId, "COVERPAGE_TITLE":that.current.COVERPAGE_TITLE, "COVERPAGE_URL":'', "COVERPAGE_DATA":that.outData};
		let inputJson={"PROCEDURE":"updatecoverpage", "USER_ID":parseInt(that.userId), "COVERPAGE_ID":that.current.COVERPAGE_ID, "COVERPAGE_TITLE":that.current.COVERPAGE_TITLE, "COVERPAGE_URL":pdfurl,"COVERPAGE_HTML_URL":htmlurl, "COVERPAGE_DATA":that.outData};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
			if(result.RESPONSE_STATUS=='N'){
				this.throwError(result);
				
			}else{
			let data={'COVERPAGE_ID': result.COVERPAGE_ID,'COVERPAGE_TITLE': result.COVERPAGE_TITLE,'COVERPAGE_URL':result.COVERPAGE_URL, "COVERPAGE_HTML_URL":result.COVERPAGE_HTML_URL};
			//that.covers.push(data);
			$('#overlay').css('display','none');
			}			
		})
	}	
	}
	getAllCover(id){
		let inputJson={"PROCEDURE":"getallcoverpages", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.covers=data.RW_COVERPAGES;
			$('#overlay').css('display','none');
			}
		})
	}
	getAllHeader(id){
		let inputJson={"PROCEDURE":"getallheaders", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.headers=data.RW_HEADERS;
			$('#overlay').css('display','none');
			}
		})
	}
	getAllFooter(id){
		let inputJson={"PROCEDURE":"getallfooters", "USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.footers=data.RW_FOOTERS;
			$('#overlay').css('display','none');
			}
		})
	}

	getAllBk(id){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"BKIMAGE"}
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			
			this.bks=data.RW_UPLOAD_FILES;
			}
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"IMAGE"}
		
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.others=data.RW_UPLOAD_FILES;
			}
		})
	} 
	private getLogo(){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"LOGO"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			this.logoInfo=data;		
			this.logos=data.RW_UPLOAD_FILES;
			}
		})
	}
	copyCover(item){
		let inputJson={"PROCEDURE":"copycoverpage","USER_ID":this.userId,"COVERPAGE_ID":item.COVERPAGE_ID};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);
				
			}else{
			this.covers.push (response);
			}
		})
	}
	getCoverPage(id){
		let inputJson={"PROCEDURE":"getcoverpage", "USER_ID":this.userId, "COVERPAGE_ID":id};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);
				
			}else{
			let data=JSON.parse(response.COVERPAGE_DATA);
			
			this.savedData=data;
			if(data.ht){
				for(let item of data.ht){
				if(item.hData){
					item.hData=this.sanitizer.bypassSecurityTrustHtml(item.hData);
					
				}
			}
				this.dataInput='ck'
			for(let i=0; i<data.ht.length; i++){
				this.selectedInsert[i]="";
				this.outDoc[i]=data.ht[i].eData;
			}
			this.pages=data.ht;
			if(!this.pages[0].bk&&data.bk&&data.bk.length>0){
				this.pages[0].bk=data.bk;
			}
			if(data.margin){
				this.pageMargin=data.margin;
			}
			if(data.page){
				this.selectpage=data.page;
			}
			
			this.bimageurl=data.bk;
			}else if(data.html){
				this.sourceCCode=data.html;
				this.dataInput='HTML';
				this.savedCHTML=[];
				this.pages=[];
				let pagedata={'eData': ' ','bk':''};
				this.selectedInsert[this.pages.length]="";
				for(let item of this.sourceCCode){
					let phtml=this.sanitizer.bypassSecurityTrustHtml(item);
					this.savedCHTML.push(phtml);	
					this.pages.push(pagedata);
				}
			}
			this.editType='C';			
			
			let index=this.covers.findIndex(cover=>cover.COVERPAGE_ID==id)
			if(index>-1){
			this.current=this.covers[index];
			this.titleService.setTitle("Cover"+' - '+this.current.COVERPAGE_TITLE);
			this.location.go('/cover/Cover-'+this.current.COVERPAGE_ID.toString());
			}
			$('#overlay').css('display','none');
		}
		})
	}
	newCover(){
		this.selectedInsert=[];
		this.selectIndex=0;
		this.content='';
		this.pages=[];
		let page={'eData': ' ', 'bk':""};
		this.pages.push(page)
		this.savedData={'ht':[{'eData': ' ', 'bk':""}]};
		let newcontent="";
		this.savedCHTML=[];
		this.sourceCCode=[];
		this.savedCHTML.push(this.sanitizer.bypassSecurityTrustHtml(newcontent)); 
		this.sourceCCode.push(newcontent)
		this.bimageurl='';
		this.docs=[page.eData];
		this.editType="C";
		this.current=null;
		this.titleService.setTitle("Cover");
		this.location.go('/cover');
		$('#overlay').css('display','none');
	}
	getCoverData(){
	
		if(this.dataInput=='ck'){
			this.outData=JSON.stringify({'ht':this.pages,'margin':this.pageMargin, 'page':this.selectpage});
		}else if(this.dataInput=='HTML'){
			this.outData=JSON.stringify({'html':this.sourceCCode,'margin':this.pageMargin, 'page':this.selectpage});
		}
		
	}

  private locations(substring,string){
  var a=[],i=-1;
  while((i=string.indexOf(substring,i+1)) >= 0) a.push(i);
  return a;
}
	public preview(){
		//this.outDoc=[];
		//this.getSecData+=1;
		setTimeout(() => {
			this.generatePdf('P');
		},500);
	}
	private generatePdf(type?){
		
		let html='';
		if(this.dataInput=='ck'){
		if(this.selectpage.type=='portrait'){
			html = this.reportService.a4Portrait;
		}else if(this.selectpage.type=='landscape'){
			html = this.reportService.a4Landscape;
		}
		}
		
		let hi='1036px';
		if(this.pages.length>0){
			for(let i=0; i<this.pages.length; i++){
				if(this.dataInput=='ck'){
					html +=`<div style="height:`+hi+`; margin:0; padding:`+this.pageMargin.top+'px '+this.pageMargin.right+'px '+this.pageMargin.bottom+'px '+this.pageMargin.left+'px'+`; background: url('`+this.pages[i].bk+`');background-repeat: no-repeat;background-size: cover;">`
					html+=this.outDoc[i];
					html += `</div>`;
					html += this.reportService.tagEnd;
				}else if(this.dataInput=='HTML'){
					html+=this.sourceCCode[i];
					
				}
			}
		}
		let cleanHtml=btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		this.reportService.generatePdf(cleanHtml, this.r,"newreport","",'Letter', this.selectpage.type, this.selectPdi, "", "", "", "N", "", [], "","", 'Y', 'Y', 'int','','',[],'',[],'','','','Y').subscribe((result) => {
   			
		if((result.status=="Y")&&(result.rurl.length>0)){
			if(type=='P'){
				window.open(result.rurl, '_blank');
			}else{
				this.save('cover',result.htmlurl, result.rurl);
			}
		}
	  })
	  
	}
	public upload(type?) {
		if(type){
			this.uploadType=type;
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			this.file.nativeElement.click();
		}else if(this.uploadType=='FILE'){
			this.file1.nativeElement.click();
		}
	}

	public uploadImage() {
	let that=this;
	this.uploadFiles=0;
		this.uploadNo=0;
	const files = this.file.nativeElement.files; 
    if(files.length==0){
		this.loading=false;
      return
    }
	const total=files.length;
		this.uploadNo=total;
	 for(let i=0; i<files.length; i++){
		const ext = files[i].name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.loading=false;
			return;
		}
    }
    for (let file of files)  
    {
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
			if(that.uploadType=='BKIMAGE'){
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
		
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
									
			})
			}else if(that.uploadType=='PHOTO'){
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
					
			})
			}else if(that.uploadType=='IMAGE'){
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
					
			})
			}else if(that.uploadType=='LOGO'){
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; 
					
			})
			}
			
		}
		reader.readAsDataURL(file);
		}
  }
  uploadFile(){
		let that=this;		
		const files = this.file1.nativeElement.files; 
		if(files.length==0){
			this.loading=false;
		return
		}
		for (let file of files){  //for multiple files
			const ext = file.name.replace(/.+\./, '');
		   if (this.acceptType.indexOf(ext) === -1) {
			   Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			   this.loading=false;
			   return;
		   }
	   }
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				that.loading=true;
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata};
				
				that.reportService.uploadFile2(inputJson).subscribe(result=>{
					that.loading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.uploadedFiles.push(result);
					
				})		
			
		}
		reader.readAsDataURL(file);
		} 
  }
  selectImg(bk){
		
		this.selectedImage=bk;
		this.selectedContainer.src=bk.BKIMAGE_URL;
		
		const nodes = this.viewer.nativeElement.querySelectorAll('div.comp');
		const nodes1 = this.viewer.nativeElement.querySelectorAll('div.ckContainer');
		let html='';
		nodes.forEach(node => {
          html += `${node.innerHTML}`;
        });
		
	}
	toImage(e){
		if($(e.target)[0].tagName=="IMG"){
			$('#imgModal').modal('show');
			this.selectedContainer=$(e.target)[0];
			this.selectedImage=null;
		}
	}
	public insertImage(){
		if(this.savedData){
			$('#insertModal').modal('show');
		}
	}
	public selectInsert(bk){
		
		if(this.selectedEditor=='C'){
			this.selectedInsert[this.selectIndex]=bk;			
		}else if(this.selectedEditor=='H'){
			this.selectedInsert[0]=bk;		
		}else if(this.selectedEditor=='F'){
			this.selectedInsert[0]=bk;		
		}

	}
	public chooseBackground(){
		if(this.savedData){
		$('#bkModal').modal('show');
		
		}
	}
	public selectBK(bk){
			this.bimageurl=bk;
			this.savedData.bk=bk;
			if(this.selectIndex>-1){
				this.pages[this.selectIndex].bk=bk;	
			}else{
				Swal.fire({
					title: 'Please select a Editor.',
					confirmButtonText: 'OK',     
				})
			}
		
	}
	public selectPage(type){
		let page:any;
		if(type=='portrait'){
			page=this.portraitSize;
		}else if(type=='landscape'){
			page=this.landscapeSize;
		}
		this.selectpage={'type':type, 'size':page};
	}
	private toStyle(data){
		let html="";
		let p1=this.locations('<figure',data); 
		let p2=this.locations('</figure>',data); 
		for(let i=0; i<p1.length; i++){
			if(i==0){
				html+=data.substring(0,p1[i]);
				let subContent=this.convertFigure(data.substring(p1[i], p2[i]+9))
				
				html+=subContent; 
			}else{
				html+=data.substring((p2[i-1]+9),p1[i]);
				let subContent=this.convertFigure(data.substring(p1[i], p2[i]+9))
				
				html+=subContent; 
			}
		}
		html+=data.substring((p2[p1.length-1]+9));
	
	 return html;
	}
	private convertFigure(node){
		let value='';
		if($(node)[0].tagName=="FIGURE"){
			let item=$(node);
			if(item.hasClass('image-style-align-left')){
				item[0].style.float='left';								
			}else if(item.hasClass('image-style-align-right')){
				item[0].style.float='right';				
			}else if(item.hasClass('image-style-align-center')){
				item[0].style.display='block';
				item[0].style.margin='auto';
			}else{
				item[0].style.display='block';
				item[0].style.margin='auto';
				if(!item[0].style.width){
					item[0].style.width='30%';
				}				
			}
			item.children('img')[0].style.width='100%';
			
			if(item.children('figcaption')[0]){
				item.children('figcaption')[0].style.textAlign = "center"
			}
			
			value=item[0].outerHTML;
		 }
		 return value; 
	}
	onSavedLogo(e){
		this.showLogo = e;
    
	}
	onEditReport(e){
		
	} 
	logOut(){
		this.logOutFlag++; 
	}
	newPage(){
		let data={'eData': ' ','bk':''};
		this.selectedInsert[this.pages.length]="";
		this.pages.push(data);
	}
	expandAll() {
    if(!this.isExpanded){
      this.groupSlots.forEach(data =>{
        this.expandedRows[data.CATEGORY] = true;
      })
	  this.isExpanded=true
	  
    } else {
      this.expandedRows={};
	  this.isExpanded = false;
    }
    
  }
  addRepeat(info){
		let content='';
		let obj={'name':info.KEY, 'dataId':info.SLOT_ID, 'dataType':'text', 'status':'N'};
		content=JSON.stringify(obj);
		this.itemIndex+=this.itemIndex;	
		let data={'index':this.itemIndex,'content':content, 'type':'slot'};
		if(this.selectedEditor=='C'){
			this.addedSlot[this.selectIndex]=data;			
		}else if(this.selectedEditor=='H'){
			this.addedHSlot[0]=data;
		}else if(this.selectedEditor=='F'){
			this.addedFSlot[0]=data;
		}
		
	}
	copyRepeat(info){
		let content='';
		content='<span class="placeholder" data-type="text">'+info.KEY+'</span>'
		navigator.clipboard.writeText(content);
	}
	
	showsavedSlot(){
		this.groupSlots.forEach(data =>{
			this.expandedRows[data.CATEGORY] = true;
		})
		this.isExpanded=true
	}
	getTable(type, data){
		this.tableContent=[];
		if(type=='Table'){
			this.tableContent=JSON.parse(data).HEADERS;
		}else if(type=='Selection'){
			this.tableContent=data.split(';'); 
		}
		
	}
	newHeader(){
		this.selectedInsert=[];
		this.editType="H";
		this.hContent='';
		this.savedHContent="";
		this.sourceHFCode='';
		let content="";
		this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(content); 
		this.hHeight=80;
		this.current=null;
		this.titleService.setTitle("Header");
		this.location.go('/cover');
		
	}
	headerContent(e){
		
		this.hContent=e;
	}
	footerContent(e){
		
		this.fContent=e;	
	}
	
	saveHF(type){
		
		let that=this;
		
		let title='';
		if(!this.current||!this.current.HF_TITLE||this.current.HF_TITLE.length==0){
		Swal.fire({
			title: 'Please input '+type.toLowerCase()+' name',
			inputAttributes: {
			autocapitalize: 'off'
		},
      html: '<input type="text" #name id="name" class="form-control mb-2" placeholder="Enter your '+type.toLowerCase()+' name"></input>',
      confirmButtonText: 'Save',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      backdrop:false,
      preConfirm: () => {
        let title = $('#name').val().trim();
        if (title === '') {
          Swal.showValidationMessage(type.toLowerCase()+` name empty`)
        }
		
		if(title.length==0) return	
		that.saveHFData(title, type, "");
      }
    })
	}else{
		title=this.current.HF_TITLE;
		if(title.length==0) return
		that.saveHFData(title, type,this.current.HEADERFOOTER_ID);
	}
		
	}
	saveHFData(title, type, id){
		
		if(title.length==0) return
		
		$('#overlay').css('display','block');
		let that=this;
		
		let html='';
		if(this.dataInput=='ck'){
			if(this.selectpage.type=='portrait'){
				html = this.reportService.a4PortraitForHF;
			}else if(this.selectpage.type=='landscape'){
				html = this.reportService.a4LandscapeForHF;
			}
		
		
		html += `<div>`;
		let hi='20px';
		html +=`<div style="margin:0; width:90%">`
		}
		let content="";
		this.hHeight=80;
		if(type=='HEADER'){
			if(this.dataInput=='ck'){
				let newHContent=this.hContent.replace("[[Document Title]]","<span class='doctitle'></span>").replace("[[Section Title]]","<span class='section'></span>").replace('Page [[x]] of [[x]]','Page <span class="page"></span> of <span class="topage"></span>').replace('Page [[x]]','Page <span class="page"></span>');
				html+=newHContent;
				content=JSON.stringify({'text':this.hContent,'height':this.hHeight, 'inputType':'ck'});
			}else if(this.dataInput=='HTML'){
				let newHContent=this.sourceHFCode.replace("[[Document Title]]","<span class='doctitle'></span>").replace("[[Section Title]]","<span class='section'></span>").replace('Page [[x]] of [[x]]','Page <span class="page"></span> of <span class="topage"></span>').replace('Page [[x]]','Page <span class="page"></span>');
				html+=newHContent;
				content=JSON.stringify({'text':this.sourceHFCode,'height':this.hHeight, 'inputType':'HTML'});
			}
		}else if(type=='FOOTER'){
			if(this.dataInput=='ck'){
			let newFContent=this.fContent.replace("[[Document Title]]","<span class='doctitle'></span>").replace("[[Section Title]]","<span class='section'></span>").replace('Page [[x]] of [[x]]','Page <span class="page"></span> of <span class="topage"></span>').replace('Page [[x]]','Page <span class="page"></span>');
			html+=newFContent;
			content=JSON.stringify({'text':this.fContent,'height':this.fHeight});
			}else if(this.dataInput=='HTML'){
				let newHContent=this.sourceHFCode.replace("[[Document Title]]","<span class='doctitle'></span>").replace("[[Section Title]]","<span class='section'></span>").replace('Page [[x]] of [[x]]','Page <span class="page"></span> of <span class="topage"></span>').replace('Page [[x]]','Page <span class="page"></span>');
				html+=newHContent;
				content=JSON.stringify({'text':this.sourceHFCode,'height':this.hHeight, 'inputType':'HTML'});
			}
		}
		if(this.dataInput=='ck'){
			html += `</div></div>`;
			html += this.reportService.tagEnd;
		}
	
		let allhtml=btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		
		let inputJson={"user_id":this.userId,"company_id":this.userInfo.COMPANY_ID.toString(),"hf_title":title,"hf_data":allhtml,"hf_content":content,"hf_id":id,"type":type};
		
		this.reportService.saveHeaderFooter(inputJson).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				return
			}
			if(type=='HEADER'){
				if(id.length==0){
					that.headers.push(data)
				}else{
					let index=that.headers.findIndex(header=>header.HEADERFOOTER_ID==data.HEADERFOOTER_ID);
					if(index>-1){
						that.headers[index]=data;
					}
				};
				let htData=JSON.parse(data.HF_DATA);
				if(!htData.inputType||(htData.inputType&&htData.inputType=='ck')){
					that.dataInput=htData.inputType;
					that.hContent=htData.text;
				}else if(htData.inputType&&htData.inputType=='HTML'){
					that.dataInput=htData.inputType;
					that.sourceHFCode=htData.text;
				}
				that.hHeight=JSON.parse(data.HF_DATA).height;
				this.location.go('/cover/Header-'+id.toString());
				this.titleService.setTitle("Header"+' - '+data.HF_TITLE);
			}else if(type=='FOOTER'){
				if(id.length==0){
					that.footers.push(data);
				}else{
					let index=that.footers.findIndex(footer=>footer.HEADERFOOTER_ID==data.HEADERFOOTER_ID);
					if(index>-1){
						that.footers[index]=data;
					}
				};
				that.fContent=JSON.parse(data.HF_DATA).text;
				that.fHeight=JSON.parse(data.HF_DATA).height;
				this.location.go('/cover/Footer-'+id.toString());
				this.titleService.setTitle("Footer"+' - '+data.HF_TITLE);
			}
			this.current=data;
			
			
			if(data.HF_URL){
				window.open(data.HF_URL, '_blank');
			}
			$('#overlay').css('display','none');
		})

	}
	copyHF(id){
		let inputJson={"PROCEDURE":"copyheaderfooter","USER_ID":this.userId,"HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);
				
			}else{
			if(response.TYPE=='HEADER'){
				this.headers.push (response);
			}else if(response.TYPE=='FOOTER'){
				this.footers.push (response);
			}
		}
		})
	}
	getHF(id){
		let inputJson2={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
			if(data.TYPE=="HEADER"){
				this.editType='H';
				if(data.HF_DATA&&data.HF_DATA.length>0){
					let htData=JSON.parse(data.HF_DATA);
					if(!htData.inputType||(htData.inputType&&htData.inputType=='ck')){
						this.dataInput=htData.inputType;
						this.hContent=htData.text;
					}else if(htData.inputType&&htData.inputType=='HTML'){
						this.dataInput=htData.inputType;
						this.sourceHFCode=htData.text;
						this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(this.sourceHFCode); 
					}
					this.hHeight=JSON.parse(data.HF_DATA).height;
					this.titleService.setTitle("Header"+' - '+data.HF_TITLE);
					this.location.go('/cover/Header-'+data.HEADERFOOTER_ID.toString());
				}
			}else if(data.TYPE=="FOOTER"){
				this.editType='F';
				if(data.HF_DATA&&data.HF_DATA.length>0){
					let htData=JSON.parse(data.HF_DATA);
					if(!htData.inputType||(htData.inputType&&htData.inputType=='ck')){
						this.dataInput=htData.inputType;
						this.fContent=htData.text;
						this.savedFContent=this.fContent;
					}else if(htData.inputType&&htData.inputType=='HTML'){
						this.dataInput=htData.inputType;
						this.sourceHFCode=htData.text;
						this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(this.sourceHFCode); 
					}
					this.fHeight=JSON.parse(data.HF_DATA).height;
					this.titleService.setTitle("Footer"+' - '+data.HF_TITLE);
					this.location.go('/cover/Footer-'+data.HEADERFOOTER_ID.toString());
				}
			}
			this.current=data;	
		$('#overlay').css('display','none');
			}			
		})
	}
	newFooter(){
		this.selectedInsert=[];
		this.editType="F";
		this.fContent='';
		this.savedHContent="";
		this.sourceHFCode='';
		let content="";
		this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(content);
		this.fHeight=80;
		this.current=null;
		this.titleService.setTitle("Footer");
		this.location.go('/cover');
	}
	saveFooter(){
		
	}
	insertPageNo(type?){
		if(type){
			let content='Page {CURRENT_PAGE} of {TOTAL_PAGES}';
			this.itemIndex+=this.itemIndex;	
			let data={'index':this.itemIndex,'content':content};
			if(this.selectedEditor=="H"){
				this.addedHPara[0]=data;
			}else if(this.selectedEditor=="F"){
				this.addedFPara[0]=data;
			}
		}else{
			let content='Page {CURRENT_PAGE}';
			this.itemIndex+=this.itemIndex;	
			let data={'index':this.itemIndex,'content':content};
			if(this.selectedEditor=="H"){
				this.addedHPara[0]=data;
			}else if(this.selectedEditor=="F"){
				this.addedFPara[0]=data;
			}
		}
	}
	deleteFile(item, type){
		
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					
					if(JSON.parse(response).RESPONSE_STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.uploadedFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}else{
						this.throwError(response);
					}
				})
			}
		})
		
	}
	updateFile(item, type, e? ){
		let data=$(e.target).siblings('textarea').val()//;item['FILE_DESCRIPTION']; 
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);
				
			}else{
			let file=JSON.parse(response);
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		}
		})
	}
	deleteCover(id){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deletecoverpage","USER_ID":parseInt(that.userId),"COVERPAGE_ID":id};
				
				that.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					
					let info=JSON.parse(response);
					let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
					if(info.RESPONSE_STATUS=="Y"){
						that.deleteItem(that.covers, 'COVERPAGE_ID', id)
						Toast.fire({
							icon: 'success',
							title: info.MESSAGE,
						})
		
					}else{
						this.throwError(info);
					}
				})
			}
		})
	}
	deleteHF(type, id){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteheaderfooter","USER_ID":parseInt(that.userId),"HEADERFOOTER_ID":id};
				
				that.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					
					let info=JSON.parse(response);
					let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
					let group=that.headers;
					if(type=='FOOTER'){
						group=that.footers;
					}
					if(info.RESPONSE_STATUS=="Y"){
						that.deleteItem(group, 'HEADERFOOTER_ID', id)
						Toast.fire({
							icon: 'success',
							title: info.MESSAGE,
						})
		
					}else{
						this.throwError(info);
					}
				})
			}
		})
	}
	deleteItem(group, field, id){
		let index=group.findIndex(item=>item[field]==id);
				if(index>-1){
					group.splice(index, 1);
				}
	}
	copySrc(type, index){
	   this.sourceCode=atob(this.samples[type][index].htmldata); 
	   
	}
	uploadHtml(type, index){
	 
	  let content=this.savedHTML;
	  if(content.length==0){
		content="";
	  }
	this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(content);
	  this.sourceCode=content;
	   
	}
	editHtml(type, index?){
	   let content=this.sourceHFCode;
	  if(this.sourceHFCode.length==0){
		content="";
	  }
		this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(content); 
		this.sourceHFCode=content;
	   
	}
	saveHFHtml(){
		$("#viewerModal").modal('hide');
		let type="HEADER";
		let that=this;
		if(this.editType=='F'){
			type="FOOTER";
		}
		Swal.fire({
			title: 'Please input '+type.toLowerCase()+' name',
			inputAttributes: {
			autocapitalize: 'off'
		},
		html: '<input type="text" #name id="name" class="form-control mb-2" placeholder="Enter your '+type.toLowerCase()+' name"></input>',
		confirmButtonText: 'Save',
		showLoaderOnConfirm: true,
		showCancelButton: true,
		backdrop:false,
		preConfirm: () => {
			let title = $('#name').val().trim();// Swal.getPopup().querySelector('#username').value;
			if (title === '') {
			Swal.showValidationMessage(type.toLowerCase()+` name empty`)
			}
			
			if(title.length==0) return	
			that.saveHtmlData(title, type);
		}
		})
	}
		saveHtmlData(title, type){
		if(title.length==0) return
		$('#overlay').css('display','block');
		let that=this;
		
		let html=this.sourceCode;
		
		let allhtml=btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		
		let inputJson={"user_id":this.userId,"company_id":this.userInfo.COMPANY_ID.toString(),"hf_title":title,"hf_data":allhtml,"hf_content":"","hf_id":"","type":type};
		
		this.reportService.saveHeaderFooter(inputJson).subscribe(data => {
			
			let item=data;
			if(type=='HEADER'){
				that.headers.push(data)
			}else if(type=='FOOTER'){
				that.footers.push(data);
			}
			if(data.HF_URL){
				window.open(data.HF_URL, '_blank');
			}
			$('#overlay').css('display','none');
		})
	
	}
	testHtml(){
		this.savedHTML=this.sanitizer.bypassSecurityTrustHtml(this.sourceHFCode);
	}
	copyUrl(url){
		navigator.clipboard.writeText(url);
	}
	editCHtml(type, index?){
	   let content=this.sourceCCode[index]; 
	  if(!this.sourceCCode[index]||this.sourceCCode[index].length==0){
		content="";
	  }
		this.savedCHTML[index]=this.sanitizer.bypassSecurityTrustHtml(content); 
		this.sourceCCode[index]=content;
		this.cIndex=index;
	   
	}
	testCHtml(index){
		this.savedCHTML[index]=this.sanitizer.bypassSecurityTrustHtml(this.sourceCCode[index]);
	}
	setDrag(data){
		if(data){
			this.dragDisabled=true;
		}else{
			this.dragDisabled=false;
		}
	}
	sideNavWidth = '60px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '60px'
			this.toggleSideBarVar = false
		}
	}
	filterSlots(e){
		let key="";
		if(e.target.tagName=='INPUT'){
			key=e.target.value.trim();;
		}else if(e.target.tagName=='I'){
			key=$(e.target).prev('input').val().trim();
		}
		let inputJson={"PROCEDURE":"searchslotsforcompany","USER_ID":parseInt(this.userId),"SLOT_KEYWORD":key};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
				
			}else{
				this.groupSlots=data.RW_SLOT_CATEGORIES;
			}
			if(!this.isExpanded){
				this.groupSlots.forEach(data =>{
					this.expandedRows[data.CATEGORY] = true;
				})
				this.isExpanded=true
				
			}
		})
	}
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
}
